// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { mergeTransactionData, setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";

const AdminTalkSendApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/talk_send";

    // API実行
    const ExecAdminTalkSendApi = async (message, history, domain) => {
        // domainにhttps://が含まれていない場合は追加する
        const formattedDomain = domain.startsWith('http://') || domain.startsWith('https://') 
        ? domain 
        : `https://${domain}`;
        
        // 必要なリクエストを定義
        const requestParams = {
            message: message,
            history: history,
            domain: formattedDomain,
            is_context: true
        };

        console.log("message : " + message)

        let response = null;
        let error = null;

        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url, requestParams});
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setTransactionData({
                tUser: response['t_user'],
            }));
        }
        return { response, error };
    };

    return ExecAdminTalkSendApi;
};

export default AdminTalkSendApi;